import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Tooltip } from '../ui';
import { OpenInNewIcon } from '../icons';

export interface EntityLinkProps {
  children: React.ReactNode;
  to: string | null | undefined;
  tooltip: string;
  state?: unknown;
}

export default function EntityLink({ children, to, tooltip, state }: EntityLinkProps) {
  const navigate = useNavigate();

  if (!to) {
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, minWidth: 0, maxWidth: '100%' }}>
        {children}
      </Box>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <Box
        role="link"
        tabIndex={0}
        onClick={(e) => { e.stopPropagation(); navigate(to, state !== undefined ? { state } : undefined); }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            navigate(to, state !== undefined ? { state } : undefined);
          }
        }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          minWidth: 0,
          maxWidth: '100%',
          cursor: 'pointer',
          borderRadius: 0.5,
          px: 0.5,
          mx: -0.5,
          '& .entity-link-icon': { opacity: 0.45, transition: 'opacity 120ms' },
          '&:hover': {
            bgcolor: 'action.hover',
            '& .entity-link-icon': { opacity: 1 },
          },
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            outlineOffset: 1,
          },
        }}
      >
        <Box sx={{ minWidth: 0 }}>{children}</Box>
        <OpenInNewIcon className="entity-link-icon" sx={{ fontSize: 14, flexShrink: 0 }} />
      </Box>
    </Tooltip>
  );
}
